import Sean from '@/modules/HomePageV2/assets/Sean.png';
import SolutionSpecialistImage1 from '@/modules/HomePageV2/assets/SolutionSpecialist-1.png';
import SolutionSpecialistImage2 from '@/modules/HomePageV2/assets/SolutionSpecialist-2.png';
import SolutionSpecialistImage3 from '@/modules/HomePageV2/assets/SolutionSpecialist-3.png';
import SolutionSpecialistImage4 from '@/modules/HomePageV2/assets/SolutionSpecialist-4.png';
import SophieSteenberg from '@/modules/HomePageV2/assets/SophieSteenberg.png';
import { WhyJoinMedrecruitCardType } from '@/modules/HomePageV2/types';

export const whyJoinMedrecruitCardData: WhyJoinMedrecruitCardType[] = [
  {
    description: 'Exclusive roles you won’t find elsewhere',
    solutionSpecialistImageSrc: SolutionSpecialistImage1.src,
    width: 175,
    height: 142,
  },
  {
    description: 'We negotiate the best rates for you',
    solutionSpecialistImageSrc: SolutionSpecialistImage2.src,
    width: 196,
    height: 143,
  },
  {
    description: 'On every recruitment panel across Australia and NZ',
    solutionSpecialistImageSrc: SolutionSpecialistImage3.src,
    width: 157,
    height: 145,
  },
  {
    description: '1:1 recruiter dedicated to your grade & specialty',
    solutionSpecialistImageSrc: SolutionSpecialistImage4.src,
    width: 189,
    height: 141,
  },
  {
    description: 'Free, end-to-end support that saves you time',
    solutionSpecialistImageSrc: SophieSteenberg.src,
    width: 173,
    height: 143,
  },
  {
    description: 'Access to Australasia’s largest doctor job network',
    solutionSpecialistImageSrc: Sean.src,
    width: 182,
    height: 143,
  },
];
